import { CARD_TYPE } from '@/utils/regex';
import { AIR_TICKET_BOOKING_TYPE } from '@features/webBooking/constants';

export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm';
export const DATE_TIME_FORMAT_LONG = 'DD/MM/YYYY HH:mm:ss';
export const DAY_FORMAT = 'dd';
export const TIME_FORMAT = 'HH:mm';
export const DATE_AND_MONTH_FORMAT = 'DD/MM';
export const MONTH_FORMAT = 'MM/YYYY';
export const FULL_DATE_TIME_FORMAT = 'HH:mm dddd, DD/MM/YYYY';
export const SHORT_DATE_FORMAT = 'D/M/YYYY';
export const DEFAULT_LOCALE = 'vi-VN';

export enum APP_TYPE {
  BOOKING = 'booking',
  PARTNER = 'partners',
  REPORT = 'reports',
  BUSINESS = 'business',
}

export const AppName = {
  [APP_TYPE.BOOKING]: 'Đơn hàng',
  [APP_TYPE.PARTNER]: 'Đối tác',
  [APP_TYPE.REPORT]: 'Báo cáo',
  [APP_TYPE.BUSINESS]: 'Nghiệp vụ',
} as const;

export enum GENDER {
  FEMALE,
  MALE,
}

export const GenderTitle = {
  [GENDER.MALE]: 'Nam',
  [GENDER.FEMALE]: 'Nữ',
};

// TODO: https://docs.google.com/spreadsheets/d/15oP07ciMcG7AcZScY5K4u3cw4-IXXyYk9kvKMXs0SGc/edit#gid=0
export enum PERMISSIONS {
  // Booking
  BOOKING = 'booking',
  BOOKING_CREATE = 'booking_create',
  BOOKING_CREATE_AIR = 'booking_create_air',
  BOOKING_CREATE_HOTEL = 'booking_create_hotel',
  BOOKING_CREATE_TICKET = 'booking_create_ticket',
  BOOKING_CREATE_INSURANCE = 'booking_create_insurance',
  BOOKING_ADD_AIR = 'booking_add_air',
  BOOKING_ADD_HOTEL = 'booking_add_hotel',
  BOOKING_ADD_TICKET = 'booking_add_ticket',
  BOOKING_ADD_INSURANCE = 'booking_add_insurance',
  BOOKING_ISSUE = 'booking_issue',
  BOOKING_ISSUE_WITH_SELECTION = 'booking_issue_with_selection',
  BOOKING_REPORT = 'booking_report',
  BOOKING_LIST = 'booking_list',
  BOOKING_LIST_AIR = 'booking_list_air',
  BOOKING_LIST_HOTEL = 'booking_list_hotel',
  BOOKING_LIST_TICKET = 'booking_list_ticket',
  BOOKING_LIST_INSURANCE = 'booking_list_insurance',
  BOOKING_WEB_CREATE = 'booking_web_create',
  BOOKING_WEB_EDIT_FEE = 'booking_web_edit_fee',
  BOOKING_SERVICE_FEE_INIT = 'booking_service_fee_init',
  BOOKING_SERVICE_FEE_REFRESH = 'booking_service_fee_refresh',
  BOOKING_USER = 'booking_user',
  BOOKING_USER_CREATE = 'booking_user_create',
  BOOKING_USER_UPDATE = 'booking_user_update',
  BOOKING_WEB = 'booking_web',
  BOOKING_WEB_UPDATE = 'booking_web_update',
  BOOKING_WEB_SETTING = 'booking_web_setting',
  BOOKING_WEB_SETTING_UPDATE = 'booking_web_setting_update',
  BOOKING_WEB_EDIT_DOMAIN = 'booking_web_edit_domain',
  BOOKING_SERVICE_FEE = 'booking_service_fee',
  BOOKING_SERVICE_FEE_CREATE = 'booking_service_fee_create',
  BOOKING_SERVICE_FEE_UPDATE = 'booking_service_fee_update',
  BOOKING_SERVICE_FEE_DELETE = 'booking_service_fee_delete',
  BOOKING_PARTNER_SETTING = 'booking_partner_setting',
  BOOKING_PARTNER_UPDATE = 'booking_partner_update',
  BOOKING_PARTNER_SETTING_SIGNIN = 'booking_partner_setting_signin',
  BOOKING_PARTNER_UPDATE_SIGNIN = 'booking_partner_update_signin',
  BOOKING_ISSUE_REFUND = 'booking_issue_refund',
  // Partner
  PARTNER = 'partner',
  PARTNER_LIST = 'partner_list',
  PARTNER_CREATE = 'partner_create',
  PARTNER_UPDATE = 'partner_update',
  PARTNER_UPDATE_PARENT = 'partner_update_parent',
  PARTNER_USER_LIST = 'partner_user_list',
  PARTNER_USER_CREATE = 'partner_user_create',
  PARTNER_USER_UPDATE = 'partner_user_update',
  PARTNER_ISSUE_FEE = 'partner_issue_fee',
  PARTNER_ISSUE_FEE_CREATE = 'partner_issue_fee_create',
  PARTNER_ISSUE_FEE_UPDATE = 'partner_issue_fee_update',
  PARTNER_ISSUE_FEE_DELETE = 'partner_issue_fee_delete',
  PARTNER_ISSUE_FEE_REFRESH = 'partner_issue_fee_refresh',
  PARTNER_ISSUE_FEE_INIT = 'partner_issue_fee_init',
  PARTNER_DEPOSIT = 'partner_deposit',
  PARTNER_DEPOSIT_UPDATE = 'partner_deposit_update',
  PARTNER_DEPOSIT_TRANSACTION = 'partner_deposit_transaction',
  PARTNER_DEPOSIT_TRANSACTION_CREATE = 'partner_deposit_transaction_create',
  PARTNER_INSURANCE_ADMINFEE = 'partner_insurance_adminfee',
  PARTNER_INSURANCE_ADMINFEE_CREATE = 'partner_insurance_adminfee_create',
  PARTNER_INSURANCE_ADMINFEE_UPDATE = 'partner_insurance_adminfee_update',
  PARTNER_INSURANCE_ADMINFEE_DELETE = 'partner_insurance_adminfee_delete',
  PARTNER_INSURANCE_ADMINFEE_REFRESH = 'partner_insurance_adminfee_refresh',
  PARTNER_INSURANCE_COMMISSION = 'partner_insurance_commission',
  PARTNER_UPDATE_SIGNIN_ALL = 'partner_update_signin_all',
  PARTNER_VIRTUAL_BANK_ACCOUNT = 'partner_virtual_bank_account',
  PARTNER_VIRTUAL_BANK_ACCOUNT_UPSERT = 'partner_virtual_bank_account_upsert',
  PARTNER_FEE_PRESET = 'partner_fee_preset',
  PARTNER_TICKET_COMMISSION = 'PARTNER_TICKET_COMMISSION',
  PARTNER_HOTEL_COMMISSION = 'PARTNER_HOTEL_COMMISSION',
  // Report
  REPORT = 'report',
  REPORT_LIST_ISSUED = 'report_list_issued',
  REPORT_LIST_VOID = 'report_list_void',
  REPORT_ADD_ISSUED = 'report_add_issued',
  REPORT_LIST_BREAKDOWN = 'report_list_breakdown',
  REPORT_LIST_REFUND = 'REPORT_LIST_REFUND',
  REPORT_LIST_REFUND_CONFIRM = 'REPORT_LIST_REFUND_CONFIRM',
  // Business Ops
  BUSINESS_OPERATION = 'business_operation',
  BUSINESS_OPERATION_CREATE = 'business_operation_create',
  BUSINESS_OPERATION_CREATE_AIR = 'business_operation_create_air',
  BUSINESS_OPERATION_CREATE_INSURANCE = 'business_operation_create_insurance',
  BUSINESS_OPERATION_CREATE_TICKET = 'business_operation_create_ticket',
  BUSINESS_OPERATION_CREATE_HOTEL = 'business_operation_create_hotel',
  BUSINESS_OPERATION_BOOKING_LIST = 'business_operation_booking_list',
  BUSINESS_OPERATION_BOOKING_LIST_AIR = 'business_operation_booking_list_air',
  BUSINESS_OPERATION_BOOKING_LIST_HOTEL = 'business_operation_booking_list_hotel',
  BUSINESS_OPERATION_BOOKING_LIST_TICKET = 'business_operation_booking_list_ticket',
  BUSINESS_OPERATION_BOOKING_LIST_INSURANCE = 'business_operation_booking_list_insurance',
  BUSINESS_OPERATION_BOOKING_MODIFY = 'business_operation_booking_modify',
  BUSINESS_OPERATION_BOOKING_ISSUE = 'business_operation_booking_issue',
  BUSINESS_OPERATION_AIRLINE_VOID = 'business_operation_airline_void',
  BUSINESS_OPERATION_LIST_ISSUED = 'business_operation_list_issued',
  BUSINESS_OPERATION_LIST_VOID = 'business_operation_list_void',
}

export enum USER_STATUS {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum ROLES {
  ADMIN = 'ADMIN',
  ACCOUNTING = 'ACCOUNTING',
  ACCOUNTING_SUB = 'ACCOUNTING_SUB',
  ISSUE = 'ISSUE',
  BOOKING = 'BOOKING',
}

export const RoleOptions = [
  { label: 'Quản trị', value: ROLES.ADMIN },
  { label: 'Kế toán chính', value: ROLES.ACCOUNTING },
  { label: 'Kế toán viên', value: ROLES.ACCOUNTING_SUB },
  { label: 'Đặt giữ chỗ', value: ROLES.BOOKING },
  { label: 'Xuất vé', value: ROLES.ISSUE },
] as const;

export enum PAYMENT_METHOD {
  PAY_LATER = 'PAY_LATER',
  PAY_NOW = 'PAY_NOW',
}

export enum BOOKING_STATUS {
  BOOK_SUCCESS = 'BOOK_SUCCESS', //Đặt giữ chỗ
  BOOK_FAILED = 'BOOK_FAILED', //Đặt lỗi
  ISSUE_WAITING = 'ISSUE_WAITING', //Chờ xuất
  ISSUE_REQUEST = 'ISSUE_REQUEST', //Yêu cầu xuất
  ISSUE_SUCCESS = 'ISSUE_SUCCESS', //Đã xuất
  ISSUE_FAILED = 'ISSUE_FAILED', //Xuất lỗi
  ISSUE_PROCESSING = 'ISSUE_PROCESSING', // Đang xuất
  CANCELED = 'CANCELED', //Đã hủy
  CHECKIN = 'CHECKIN', //Đã check-in
  DELETED = 'DELETED', // Đã xoá
  VOID_SUCCESS = 'VOID_SUCCESS', //Đã void
  VOID_FAILED = 'VOID_FAILED', //Void lỗi
  REFUND_FAILED = 'REFUND_FAILED', //Hoàn tiền lỗi
  REFUND_CONFIRM = 'REFUND_CONFIRM', //Hoàn tiền cần xác nhận
  REFUND_PROCESSING = 'REFUND_PROCESSING', //Hoàn tiền đang xử lý
  REFUND_SUCCESS = 'REFUND_SUCCESS', //Đã hoàn tiền
}

export enum REPORT_TYPE {
  AIRLINE = 'AIRLINE',
  TICKET = 'TICKET',
  HOTEL = 'HOTEL',
  INSURANCE = 'INSURANCE',
  TOUR = 'TOUR',
}

export const ReportTypeTitle = {
  [REPORT_TYPE.AIRLINE]: 'Vé máy bay',
  [REPORT_TYPE.TICKET]: 'Vé vui chơi',
  [REPORT_TYPE.HOTEL]: 'Khách sạn',
  [REPORT_TYPE.INSURANCE]: 'Bảo hiểm',
  [REPORT_TYPE.TOUR]: 'Tour',
};

export const ReportTypeOptions = [
  { label: 'Vé máy bay', value: REPORT_TYPE.AIRLINE },
  { label: 'Vé vui chơi', value: REPORT_TYPE.TICKET },
  { label: 'Khách sạn', value: REPORT_TYPE.HOTEL },
  { label: 'Bảo hiểm', value: REPORT_TYPE.INSURANCE },
  //TODO: Tạm thời đóng
  // { label: 'Tour', value: REPORT_TYPE.TOUR },
] as const;

export const BookingStatusOptions = [
  { [BOOKING_STATUS.BOOK_SUCCESS]: 'Đặt chỗ thành công' },
  { [BOOKING_STATUS.BOOK_FAILED]: 'Đặt chỗ lỗi' },
  { [BOOKING_STATUS.ISSUE_WAITING]: 'Chờ xuất' },
  { [BOOKING_STATUS.ISSUE_PROCESSING]: 'Đang xuất' },
  { [BOOKING_STATUS.ISSUE_REQUEST]: 'Yêu cầu xuất' },
  { [BOOKING_STATUS.ISSUE_SUCCESS]: 'Xuất thành công' },
  { [BOOKING_STATUS.ISSUE_FAILED]: 'Xuất lỗi' },
  { [BOOKING_STATUS.CANCELED]: 'Đã huỷ' },
  { [BOOKING_STATUS.CHECKIN]: 'Đã Check-in' },
  { [BOOKING_STATUS.DELETED]: 'Đã xoá' },
  { [BOOKING_STATUS.VOID_SUCCESS]: 'Đã void' },
  { [BOOKING_STATUS.VOID_FAILED]: 'Void lỗi' },
] as const;

export enum PARTNER_AIR_TICKET_SERVICE_MANAGEMENT_ACTIONS {
  INIT_DEFAULT = 'INIT_DEFAULT',
  REFRESH = 'REFRESH',
  APPLY_PRESET = 'APPLY_PRESET',
  APPLY_TO_CHILDREN = 'APPLY_TO_CHILDREN',
}

export enum PARTNER_UPDATE_TYPE {
  SELF = 'SELF',
  CHILDREN = 'CHILDREN',
}

export enum TRANSACTION_TYPE {
  AUTOMATIC = 'AUTOMATIC',
  MODIFY = 'MODIFY',
}

export const AcceptedBookingPaymentStatus = [
  BOOKING_STATUS.BOOK_SUCCESS,
  BOOKING_STATUS.ISSUE_SUCCESS,
  BOOKING_STATUS.ISSUE_REQUEST,
  BOOKING_STATUS.ISSUE_FAILED,
] as BOOKING_STATUS[];

export const LanguageOptions = [
  { value: 'VN', label: 'Tiếng Việt' },
  { value: 'EN', label: 'Tiếng Anh' },
];

export const IconCreditCardType: Record<'type' | 'src', string>[] = [
  {
    type: CARD_TYPE.VISA,
    src: `${process.env.PUBLIC_URL}/assets/svgs/creditCard/visa.svg`,
  },
  {
    type: CARD_TYPE.MASTER_CARD,
    src: `${process.env.PUBLIC_URL}/assets/svgs/creditCard/mastercard.svg`,
  },
  {
    type: CARD_TYPE.JCB,
    src: `${process.env.PUBLIC_URL}/assets/svgs/creditCard/jcb.svg`,
  },
  {
    type: CARD_TYPE.AMERICAN_EXPRESS,
    src: `${process.env.PUBLIC_URL}/assets/svgs/creditCard/amex.svg`,
  },
  {
    type: CARD_TYPE.DISCOVER,
    src: `${process.env.PUBLIC_URL}/assets/svgs/creditCard/discover.svg`,
  },
  {
    type: CARD_TYPE.DINERS_CLUB,
    src: `${process.env.PUBLIC_URL}/assets/svgs/creditCard/diners.svg`,
  },
  {
    type: CARD_TYPE.UNION_PAY,
    src: `${process.env.PUBLIC_URL}/assets/svgs/creditCard/unionpay.svg`,
  },
  {
    type: CARD_TYPE.ELO,
    src: `${process.env.PUBLIC_URL}/assets/svgs/creditCard/elo.svg`,
  },
];

export const Gender = [
  { value: GENDER.MALE, label: 'Nam' },
  { value: GENDER.FEMALE, label: 'Nữ' },
];

export enum PAYMENT_OPTION {
  DEPOSIT = 'DEPOSIT',
  CREDIT_CARD = 'CREDIT_CARD',
}

export const PaymentOptionTitle = {
  [PAYMENT_OPTION.DEPOSIT]: 'Ký quỹ',
  [PAYMENT_OPTION.CREDIT_CARD]: 'Thanh toán thẻ khách',
};

export enum REFUND_MODE {
  FULLY,
  PARTIAL,
  NO_REFUND,
}

export enum AIRLINE_BRANDS {
  VN = 'VN',
  QH = 'QH',
  VJ = 'VJ',
  VU = 'VU',
  BL = 'BL',
  S9G = '9G',
}

export const AirlineBrandNames = {
  [AIRLINE_BRANDS.VN]: 'Vietnam Airlines',
  [AIRLINE_BRANDS.QH]: 'Bamboo Airways',
  [AIRLINE_BRANDS.VJ]: 'VietJet Air',
  [AIRLINE_BRANDS.VU]: 'Vietravel Airlines',
  [AIRLINE_BRANDS.BL]: 'Pacific Airlines',
  [AIRLINE_BRANDS.S9G]: 'Sun Phu Quoc Airways',
} as const;

export const ItineraryType = [
  {
    label: 'Một chiều',
    value: AIR_TICKET_BOOKING_TYPE.ONE_WAY,
  },
  {
    label: 'Khứ hồi',
    value: AIR_TICKET_BOOKING_TYPE.ROUND_TRIP,
  },
] as const;

export const MAX_COMPANY_ADDRESS_LENGTH = 500;
export const MAX_COMPANY_NAME_LENGTH = 500;
export const MAX_RECEIVER_NAME_LENGTH = 250;
export const MAX_CONTACT_NOTE_LENGTH = 250;
export const MAX_COMPANY_CITY_NAME_LENGTH = 100;
export const MAX_CLASS_LENGTH = 100;
export const MAX_AIRLINE_CODE_LENGTH = 2;
export const MAX_BOOKING_CODE_LENGTH = 6;
export const MAX_INSURED_COUNT = 100;
export const MAX_WEB_SERVICE_DESCRIPTION_LENGTH = 200;
export const MAX_PARTNER_NAME_LENGTH = 250;
export const MAX_FREQUENT_FLYER_NUMBER_LENGTH = 20;
export const MAX_INFANT_AGE = 2;
export const MAX_CHILDREN_AGE = 12;
export const MAX_TRAVEL_DOCUMENT_COUNTRY_CODE_LENGTH = 3;

export const WAIT_TIME = 500; //ms

export const EmptyImage =
  'data:image/png;base64,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';

export const IsrExampleFileLink = `https://eap.787.vn/Assets/Insurance/Documents/ISR_Example.xlsx`;

export enum TRAVEL_DOCUMENT_INPUT {
  NATIONALITY_CODE = 'NATIONALITY_CODE',
  DOCUMENT_NUMBER = 'DOCUMENT_NUMBER',
  EXPIRY_DATE = 'EXPIRY_DATE',
  ISSUING_COUNTRY_CODE = 'ISSUING_COUNTRY_CODE',
  BIRTHDAY = 'BIRTHDAY',
  GENDER = 'GENDER',
}

export const TravelDocumentInputTitle = {
  [TRAVEL_DOCUMENT_INPUT.NATIONALITY_CODE]: 'Mã quốc tịch',
  [TRAVEL_DOCUMENT_INPUT.DOCUMENT_NUMBER]: 'Số hộ chiếu',
  [TRAVEL_DOCUMENT_INPUT.EXPIRY_DATE]: 'Ngày hết hạn',
  [TRAVEL_DOCUMENT_INPUT.ISSUING_COUNTRY_CODE]: 'Mã quốc gia cấp',
  [TRAVEL_DOCUMENT_INPUT.BIRTHDAY]: 'Ngày sinh',
  [TRAVEL_DOCUMENT_INPUT.GENDER]: 'Giới tính',
} as const;

export const LOCAL_STORAGE_APP_VERSION_KEY = 'version';

export enum PASSENGER_TYPE {
  ADULT = 'adult',
  CHILDREN = 'children',
  INFANT = 'infant',
}

export const PassengerTypeTitle = {
  [PASSENGER_TYPE.ADULT]: 'Người lớn',
  [PASSENGER_TYPE.CHILDREN]: 'Trẻ em',
  [PASSENGER_TYPE.INFANT]: 'Em bé',
};

export enum TOUR_TYPE {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  SINGLE_DAY = 'SINGLE_DAY',
  MULTIPLE_DAY = 'MULTIPLE_DAY',
}

export const TourType = {
  [TOUR_TYPE.DAILY]: 'Hàng ngày',
  [TOUR_TYPE.WEEKLY]: 'Hàng tuần',
  [TOUR_TYPE.SINGLE_DAY]: 'Một ngày',
  [TOUR_TYPE.MULTIPLE_DAY]: 'Nhiều ngày',
};

export enum WEEK_DAY {
  SUNDAY = 'Sunday',
  MONDAY = 'Monday',
  TUESDAY = 'Tuesday',
  WEDNESDAY = 'Wednesday',
  THURSDAY = 'Thursday',
  FRIDAY = 'Friday',
  SATURDAY = 'Saturday',
}

export const WeekDay = {
  [WEEK_DAY.SUNDAY]: 'Chủ nhật',
  [WEEK_DAY.MONDAY]: 'Thứ hai',
  [WEEK_DAY.TUESDAY]: 'Thứ ba',
  [WEEK_DAY.WEDNESDAY]: 'Thứ tư',
  [WEEK_DAY.THURSDAY]: 'Thứ năm',
  [WEEK_DAY.FRIDAY]: 'Thứ sáu',
  [WEEK_DAY.SATURDAY]: 'Thứ bảy',
};

export enum SORT_TYPE {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING',
}

export const bookingDeletablePartner = 'ADC-SUP';

export enum COMMISSION_ACTION {
  REFRESH = 'REFRESH',
  APPLY_PRESET = 'APPLY_PRESET',
  APPLY_TO_CHILDREN = 'APPLY_TO_CHILDREN',
}

export const DEFAULT_PAGE_SIZE = 20;

export enum TICKET_TYPE {
  ADT = 'ADT',
  CHD = 'CHD',
  INF = 'INF',
  SSR = 'SSR',
  SEAT = 'SEAT',
  XBAG = 'XBAG',
  ALL = 'ALL',
}

export const ticketTypeOptions = [
  { value: TICKET_TYPE.ADT, label: TICKET_TYPE.ADT },
  { value: TICKET_TYPE.CHD, label: TICKET_TYPE.CHD },
  { value: TICKET_TYPE.INF, label: TICKET_TYPE.INF },
  { value: TICKET_TYPE.SSR, label: TICKET_TYPE.SSR },
  { value: TICKET_TYPE.SEAT, label: TICKET_TYPE.SEAT },
  { value: TICKET_TYPE.XBAG, label: TICKET_TYPE.XBAG },
  { value: TICKET_TYPE.ALL, label: 'Toàn bộ' },
] as const;

export const typeMap: Record<string, string> = {
  ADULT: 'ADT',
  CHILDREN: 'CHD',
  INFANT: 'INF',
  SSR: 'SSR',
  SEAT: 'SEAT',
  XBAG: 'XBAG',
  ALL: 'ALL',
};

// Kênh xuất
export enum VIA {
  ADE = 'ADE',
  API = 'API',
  ADC = 'ADC',
  AIR = 'AIR',
  SUP = 'SUP',
}

export const viaOptions = [
  { value: VIA.ADE, label: VIA.ADE },
  { value: VIA.API, label: VIA.API },
  { value: VIA.ADC, label: VIA.ADC },
  { value: VIA.AIR, label: VIA.AIR },
  { value: VIA.SUP, label: VIA.SUP },
];

export enum REACT_QUERY_KEY {
  USER_LIST = 'userList',
  SERVICES_LIST = 'servicesList',
  PARTNER_LIST = 'partnerList',
  REFUNDED_BOOKING_LIST = 'refundedBookingList',
  REPORT_STATISTICS = 'reportStatistics',
  PLACE_SELECT = 'placeSelect',
  AIRLINE_BOOKING_LIST = 'airlineBookingList',
  AMUSEMENT_BOOKING_LIST = 'amusementBookingList',
  INSURANCE_BOOKING_LIST = 'insuranceBookingList',
  TOUR_BOOKING_LIST = 'tourBookingList',
  HOTEL_BOOKING_LIST = 'hotelBookingList',
  TOUR_DESTINATIONS = 'tourDestinations',
  REFUNDED_BOOKING_DETAIL = 'refundedBookingDetail',
  HOTEL_ASSET_MASTER_DATA = 'hotelAssetMasterData',
  AIRPORTS = 'airports',
  HOTEL_DESTINATIONS = 'hotel-destinations',
  AIRLINE_PROMOTIONS = 'airlinePromotions',
  SEARCH_PRODUCTS = 'searchProducts',
  BOOKING_DETAIL = 'booking-detail',
  USER_BOOKER_INFO = 'user-booker-info',
}
